import repository from "../Repository";

export default {
  unfinished(screenId) {
    return repository.post(
      `disaster_info`,
      {
        disaster_unfinished: "true"
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  latest(screenId) {
    return repository.post(
      `disaster_info`,
      { disaster_latest: "true" },
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  list(screenId) {
    return repository.post(
      `disaster_info`,
      {},
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
